// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_f18bac0","tileContainer":"_dfb9a29","tile":"_9ed10b3","gameImage":"_469a6ca","loader":"_c4028ba"};